import{jsx as t,Fragment as e}from"react/jsx-runtime";import{useState as o,useEffect as n}from"react";import{useTranslation as r}from"react-i18next";import a from"styled-components";import{DEFAULT_LANG as s,NAMESPACE as m}from"../../../constants/translationsConstants.js";import{i18nInstance as i}from"../../../translationsInstance.js";import l from"../../../../../assets/locales/en-US.json.js";import{Loader as c}from"../../Loader/Loader.js";const d=a.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 200px;
`,p=a(c)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;i.addResourceBundle(s,m,l);const g=({children:a,languageCode:m})=>{const[l,c]=o(s===m),{ready:g}=r();return n((()=>{g&&(c(!0),document.documentElement.lang=i.language,m&&i.language!==m&&(c(!1),i.changeLanguage(m,(()=>{document.documentElement.lang=m,c(!0)}))))}),[m,g]),t(e,{children:l?a:t(d,{children:t(p,{})})})};export{g as TranslationsInitializer};
//# sourceMappingURL=TranslationsInitializer.js.map
